export enum Routes {
  LOGIN = '/login',
  DASHBOARD = '/',
  MENUS = '/menus',
  PRODUCT_LIBRARY = '/items',
  INVENTORY = '/inventory',
  VENUES = '/venues',
  PRICE_SCHEMES = '/price-schemes',
  PRICE_MANAGEMENT = '/price-management',
  PRICE_RULES = '/price-rules',
  PRICE_BANDS = '/price-bands',
  ADMIN = '/admin',
}
